// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/asset/coin_market_cap.proto" (package "mlmbox.client.asset", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CoinMarketCap } from "./coin_market_cap.ts";
import type { Asset_MarketCap_List } from "../../types/asset.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Asset_MarketCap } from "../../types/asset.ts";
import type { Asset_Id } from "../../types/asset.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.asset.CoinMarketCap
 */
export interface ICoinMarketCapClient {
    /**
     * @generated from protobuf rpc: Get(mlmbox.types.Asset.Id) returns (mlmbox.types.Asset.MarketCap);
     */
    get(input: Asset_Id, options?: RpcOptions): UnaryCall<Asset_Id, Asset_MarketCap>;
    /**
     * @generated from protobuf rpc: All(google.protobuf.Empty) returns (mlmbox.types.Asset.MarketCap.List);
     */
    all(input: Empty, options?: RpcOptions): UnaryCall<Empty, Asset_MarketCap_List>;
}
/**
 * @generated from protobuf service mlmbox.client.asset.CoinMarketCap
 */
export class CoinMarketCapClient implements ICoinMarketCapClient, ServiceInfo {
    typeName = CoinMarketCap.typeName;
    methods = CoinMarketCap.methods;
    options = CoinMarketCap.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(mlmbox.types.Asset.Id) returns (mlmbox.types.Asset.MarketCap);
     */
    get(input: Asset_Id, options?: RpcOptions): UnaryCall<Asset_Id, Asset_MarketCap> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Asset_Id, Asset_MarketCap>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: All(google.protobuf.Empty) returns (mlmbox.types.Asset.MarketCap.List);
     */
    all(input: Empty, options?: RpcOptions): UnaryCall<Empty, Asset_MarketCap_List> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Asset_MarketCap_List>("unary", this._transport, method, opt, input);
    }
}
